'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hublessCheckAuth;

var _noPortalApiClient = require('../utils/http/noPortalApiClient');

var _noPortalApiClient2 = _interopRequireDefault(_noPortalApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hublessCheckAuth() {
  return _noPortalApiClient2.default.get('/users/v2/app/users/plus-hub-ids/hubless', {
    ignoreRedirect: true
  });
}
module.exports = exports['default'];